import React from "react";
import ChatMainIcon from "../../assets/chaticon.png";
import SearchIcon from "@mui/icons-material/Search";
import ModeCommentRoundedIcon from "@mui/icons-material/ModeCommentRounded";
import { useNavigate } from "react-router-dom";
import "./ChatPageMainScreen.css";
import { useChatContext } from "../../../../context";

const ChatHomePage = () => {
  const navigate = useNavigate();
  const { chatAI } = useChatContext();
  const { isCodieActive, setIsCodieActive } = chatAI;

  const handleNavigate = (isCodieActive, path) => {
    // setIsCodieActive(isCodieActive);
    navigate(path);
  };

  return (
    <div
      style={{
        display: "flex",
        height: "80%",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ marginBottom: "20px" }}>
        <div className="d-flex justify-content-center">
          <img src={ChatMainIcon} alt="HelpIcon" />
        </div>
        <p style={{ color: "#032F49", fontSize: "18px" }}>
          How can I help you today?
        </p>
      </div>

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div
          onClick={() => handleNavigate(true, "/ChatAi")}
          className="chat-box"
          style={{ marginRight: "10px" }}
        >
          <p>Ask Codie A Question</p>
          <ModeCommentRoundedIcon sx={{ color: "#b6d7ea", ml: "5px" }} />
        </div>

        <div
          onClick={() => handleNavigate(false, "/SearchCodingAdvice")}
          className="chat-box"
        >
          <p>Advice Search</p>
          <SearchIcon sx={{ color: "#b6d7ea", fontSize: 30, ml: "5px" }} />
        </div>
      </div>
    </div>
  );
};

export default ChatHomePage;
